import React, { useCallback, useState } from 'react';
import LoadedDataTable from '../../../../Elements/DataTable/LoadedDataTable';
import InvoiceAutomationService from '../../../../Services/InvoiceAutomationService';
import InvoiceAutomationRunItem from '../../../../Domain/ThirdParty/Project/InvoiceAutomationRunItem';
import InvoiceAutomationRunDetail from './InvoiceAutomationRunDetail';

// Every run of a project's automatic invoicing, newest first; a run's start time and its row action open its details.
export default function InvoiceAutomationRunList({ projectId = null, projectName = '', clientId = null }) {
  const [selectedRun, setSelectedRun] = useState(null);
  const loadRuns = useCallback(() => InvoiceAutomationService.GetInvoiceAutomationRuns(projectId), [projectId]);

  InvoiceAutomationRunItem.openDetailFunction = (run) => setSelectedRun(run);

  return (
    <>
      <LoadedDataTable
        load={loadRuns}
        failureMessage='Error! ErrorCode: IARL18. Failed to load the automatic invoicing runs.'
        type={InvoiceAutomationRunItem}
        emptyMessage='The automation has not run yet.'
      />
      {selectedRun !== null && (
        <InvoiceAutomationRunDetail
          runId={selectedRun.InvoiceAutomationRunId}
          projectName={projectName}
          clientId={clientId}
          onClose={() => setSelectedRun(null)}
        />
      )}
    </>
  );
}
